import LoginLoading from './LoginLoading.class.js'
import PageLoading from './PageLoading.class.js'

export {
  LoginLoading,
  PageLoading,
}
